import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import service from "./sidebaricon/Services.png";
import allServices from "./allServices";
import { AnimatedModal } from './ReusableComponents/AnimatedModal';
import reqServiceIcon from './assets/reqService.png';
import * as API from "./api.js";
import { getActiveTeam } from './Teams';
import { Popup } from './ReusableComponents/reusableFunctions.js';
import picstorkHover from "./icons/picstork-hover.svg";
import enterpriseHover from "./icons/enterprise-hover.svg";
import rectangle from "./icons/rectangle.svg"

export default class ServicesTileTray extends Component {
    state = {
        tiles: [],
        type: '',
        inactiveTiles: [],
        requestServiceModal: false,
        reqMessage: "Thank you for your interest, we will activate selected service in your account at the earliest once requested.",
        reqSent: {
            0: false,
            1: false,
            2: false
        },
        reqSentMessage: "The confirmation email will be sent to your account",
        mainServices: "false",
        hoverService: null
    }

    componentWillMount() {
        getActiveTeam().then(activeTeam => {
            this.setState({
                activeTeam: activeTeam
            }, () => {
                const { user, type, tiles, sidebarMode, mainServices } = this.props;
                if (mainServices === "true") {
                    let inactiveTiles = allServices.services.filter(({ title: id1 }) => !tiles.some(({ title: id2 }) => id2 === id1));
                    this.setState({
                        user,
                        type,
                        tiles,
                        sidebarMode,
                        inactiveTiles,
                        mainServices
                    });
                }
            });
        });
    }

    sendServiceRequest = (serviceTitle) => {
        API.request_service(serviceTitle).then(response => {
            let activeKey = this.state.key;
            this.setState(state => ({
                reqSent: { ...state.reqSent, [activeKey]: true }
            }));
        });
    }

    getHoverBackground = (title) => {
        switch (title) {
            case "PicStork":
                return `url(${picstorkHover})`;
            case "AeroGCS Enterprise":
                return `url(${enterpriseHover})`;
            default:
                return "";
        }
    }

    render() {
        let { user, type, sidebarMode, tiles, inactiveTiles, requestServiceModal, hoverService } = this.state;
        const customOrder = ["PicStork", "DroneNaksha", "AeroGCS Enterprise"];

        return (
            <div style={{ width: "100%" }}>
                <div style={{ width: "100%", marginTop: "2%", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                    <div className='content-text' style={{ fontSize: "22px", fontWeight: "700", color: "#2989cf" }}>Welcome to AeroMegh</div>
                    <div className='content-text' style={{ fontSize: "14px", margin: "1% 1% 1% 2%", width: "70%", fontWeight: "700", color: "#3c3c3c", textAlign: "center" }}>
                        <p>{"AeroMegh is a SaaS platform offering multiple services. Each service is uniquely designed with the highest security (level1) and simplicity to address the needs of the drone ecosystem."}</p>
                    </div>
                </div>

                <div style={{ display: "flex", justifyContent: "center", width: "100%", marginTop: "30px", flexWrap: "wrap", gap: "20px" }}>
                    {
                        tiles.sort((a, b) => {
                            return customOrder.indexOf(a.title) - customOrder.indexOf(b.title);
                        }).map((service) => {
                            const cardStyle = {
                                backgroundImage: hoverService === service.title ? this.getHoverBackground(service.title) : "none",
                                backgroundSize: service.title === "PicStork" ? "cover" : "100% 100%",
                                backgroundPosition: 'center',
                                transition: 'all 0.3s ease',
                                cursor: "pointer",
                                position: 'relative',
                            };

                            return (
                                service.title === 'AeroGCS Enterprise' ? (
                                    <div
                                        onMouseEnter={() => this.setState({ hoverService: service.title })}
                                        onMouseLeave={() => this.setState({ hoverService: null })}
                                        onClick={() => {
                                            Popup.alert("CUSTOM", <div>AeroGCS Enterprise has been migrated to new home <a href='https://enterprise.aerogcs.com' target='_blank'>https://enterprise.aerogcs.com</a>, click ok to visit, you will have to login one more time</div>, () => {
                                                window.open('https://enterprise.aerogcs.com', '_blank');
                                            }, () => { }, "200px", "", "Ok");
                                        }}
                                        className='service-card'
                                        style={cardStyle}
                                    >
                                        {hoverService === service.title && (
                                            <img
                                                src={rectangle}
                                                alt="hover-overlay"
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '10px',
                                                    zIndex: 2,
                                                    pointerEvents: 'none'
                                                }}
                                            />
                                        )}
                                        <div className='service-icon'>
                                            <img style={{ height: "200px", width: "200px" }} src={service.image} alt="imageIcon" />
                                        </div>
                                        <div className='content-text' style={{ display: "flex", alignItems: "center", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#666666", margin: "2% 6%" }}>
                                            {service.description.length <= 200 ? service.description : service.description.substr(0, 47) + "..."}
                                        </div>
                                    </div>
                                ) : (
                                    <Link
                                        to={{
                                            pathname: service.redirectURL || service.redirecturl,
                                            state: {
                                                user,
                                                type,
                                                service,
                                                sidebarMode
                                            }
                                        }}
                                        className='service-card'
                                        onMouseEnter={() => this.setState({ hoverService: service.title })}
                                        onMouseLeave={() => this.setState({ hoverService: null })}
                                        style={cardStyle}
                                    >
                                        {hoverService === service.title && (
                                            <img
                                                src={rectangle}
                                                alt="hover-overlay"
                                                style={{
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '10px',
                                                    zIndex: 2,
                                                    pointerEvents: 'none'
                                                }}
                                            />
                                        )}
                                        <div className='service-icon'>
                                            <img
                                                style={service.title === "PicStork" ? { height: "130px", width: "130px" } : { height: "150px", width: "150px" }}
                                                src={service.image}
                                                alt="imageIcon"
                                            />
                                        </div>
                                        <div className='content-text' style={{ display: "flex", alignItems: "center", textAlign: "center", fontSize: "12px", fontWeight: "700", color: "#666666", margin: "2% 6%" }}>
                                            {service.description.length <= 200 ? service.description : service.description.substr(0, 47) + "..."}
                                        </div>
                                    </Link>
                                )
                            );
                        })
                    }
                </div>
            </div>
        );
    }
}